import { useEffect } from 'react';
import { observer } from 'mobx-react';

import { Checkbox, Input } from '@gamesb42/ui-kit';
import { appInfoInst } from '.';

// Типы для UA источников
type UASpendSource = keyof typeof appInfoInst.values.uaSpend;

// Список UA источников с человекочитаемыми названиями
const UA_SPEND_OPTIONS: { key: UASpendSource; label: string }[] = [
  { key: 'facebook', label: 'Facebook' },
  { key: 'googleAds', label: 'Google Ads' },
  { key: 'appleSearchAds', label: 'Apple Search Ads' },
  { key: 'snapchat', label: 'Snapchat' },
  { key: 'tikTok', label: 'Tik Tok' },
  { key: 'unityAds', label: 'UnityAds' },
  { key: 'dontKnow', label: "I don't know" },
  { key: 'other', label: 'Other' },
];

// Переиспользуемый компонент для UA источника
const UASpendOptionComponent = observer(
  ({
    sourceKey,
    label,
    checked,
    onToggle,
  }: {
    sourceKey: UASpendSource;
    label: string;
    checked: boolean;
    onToggle: (sourceKey: UASpendSource, checked: boolean) => void;
  }) => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        height: '24px', // Фиксированная высота для выравнивания
      }}
    >
      <Checkbox
        checked={checked}
        onChange={(e) => onToggle(sourceKey, e.target.checked)}
      >
        {label}
      </Checkbox>
    </div>
  ),
);

const Step3 = observer(() => {
  useEffect(() => {
    appInfoInst.isStepIsValid[3] = Object.values(
      appInfoInst.values.uaSpend,
    ).some((el) => el === true);
  }, [
    appInfoInst.values.uaSpend.facebook,
    appInfoInst.values.uaSpend.googleAds,
    appInfoInst.values.uaSpend.appleSearchAds,
    appInfoInst.values.uaSpend.snapchat,
    appInfoInst.values.uaSpend.tikTok,
    appInfoInst.values.uaSpend.unityAds,
    appInfoInst.values.uaSpend.dontKnow,
    appInfoInst.values.uaSpend.other,
  ]);

  // Функция для переключения UA источника
  const toggleUASpendSource = (sourceKey: UASpendSource, checked: boolean) => {
    if (sourceKey === 'otherComment') return; // Защита от изменения комментария
    appInfoInst.values.uaSpend[sourceKey] = checked;
  };

  return (
    <>
      <h3>
        <b>UA spends sources*</b>
      </h3>
      <div
        style={{
          marginTop: '20px',
          display: 'flex',
          flexDirection: 'column',
          gap: '32px',
        }}
      >
        {UA_SPEND_OPTIONS.map(({ key, label }) => (
          <UASpendOptionComponent
            key={key}
            sourceKey={key}
            label={label}
            checked={Boolean(appInfoInst.values.uaSpend[key])}
            onToggle={toggleUASpendSource}
          />
        ))}
      </div>

      {/* Поле для комментария к Other */}
      {appInfoInst.values.uaSpend.other && (
        <div style={{ marginTop: '32px' }}>
          <Input
            size="large"
            label="Enter your UA spends sources"
            value={appInfoInst.values.uaSpend.otherComment}
            onChange={(e) => {
              appInfoInst.values.uaSpend.otherComment = e.target.value;
            }}
          />
        </div>
      )}
    </>
  );
});

export default Step3;
